// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jx-0";